import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';

const AlreadyUpdateStep: React.FC = () => {
    return (
        <div className="p-6">
            <div className="text-center">
                <CheckCircleIcon className="mx-auto h-16 w-16 text-green-500 mb-4" />
                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                    Seus Dados Estão Atualizados!
                </h2>
            </div>

            <div className="text-gray-600 space-y-4">
                <p>
                    Ótimas notícias! Verificamos nossos registros e suas informações já estão atualizadas em nosso sistema.
                </p>

                <div className="bg-green-50 p-4 rounded-md border-l-4 border-green-400">
                    <p className="text-green-800 font-medium">
                        ✅ Não é necessário fazer nenhuma atualização no momento.
                    </p>
                </div>

                <p>
                    Seus dados estão em conformidade com nossas políticas e todos os campos obrigatórios foram preenchidos corretamente.
                </p>

                <div className="bg-blue-50 p-4 rounded-md border-l-4 border-blue-400">
                    <p className="text-blue-800 font-medium">
                        💡 Lembrete: Caso suas informações pessoais mudem no futuro (endereço, telefone, estado civil, etc.), não esqueça de nos comunicar para mantermos tudo atualizado.
                    </p>
                </div>

                <p>
                    Obrigado por manter seus dados sempre em dia! Isso nos ajuda a oferecer o melhor serviço possível.
                </p>
            </div>

            <div className="mt-8 text-center">
                <Link
                    to="/dashboard"
                    className="bg-indigo-600 text-white px-8 py-3 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                    Voltar para o Início
                </Link>
            </div>
        </div>
    );
};

export default AlreadyUpdateStep;
